<section id="hero" class="hero-section relative min-h-screen flex items-center overflow-hidden">
  <div class="hero-bg"></div>
  <div class="hero-grid"></div>
  <div class="orb orb-1"></div>
  <div class="orb orb-2"></div>
  <div class="orb orb-3"></div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-24 pb-12">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="hero-text">
        <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full badge mb-6">
          <span class="badge-dot"></span>
          <span class="text-sm font-medium badge-label">Trieon Technologies</span>
        </div>

        <h1 class="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-6">
          We Build
          <span class="gradient-text block">Digital Solutions</span>
          That Scale
        </h1>

        <p class="text-lg leading-relaxed mb-8 max-w-xl hero-lead">
          Trieon Technologies designs and delivers software systems for businesses — from client
          platforms to SaaS products and mobile apps, built end to end.
        </p>

        <div class="flex flex-wrap gap-2 mb-10">
          @for (tag of capabilities; track tag) {
            <span class="capability-tag">{{ tag }}</span>
          }
        </div>

        <div class="flex flex-wrap gap-4">
          <button
            class="cta-primary flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold text-white"
            (click)="scrollToSection('#projects')"
          >
            <i class="pi pi-th-large"></i>
            View Our Work
          </button>
          <button
            class="cta-secondary flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold"
            (click)="scrollToSection('#contact')"
          >
            <i class="pi pi-send"></i>
            Let's Talk
          </button>
        </div>
      </div>

      <div class="hero-visual relative flex justify-center items-center">
        <div class="hero-card main-card">
          <div class="card-header">
            <div class="flex items-center gap-2 mb-4">
              <div class="dot dot-red"></div>
              <div class="dot dot-yellow"></div>
              <div class="dot dot-green"></div>
            </div>
            <span class="text-xs font-mono card-label">trieon.tech</span>
          </div>
          <div class="code-lines">
            <div class="code-line"><span class="code-keyword">const&nbsp;</span><span class="code-var">solution</span> = <span class="code-fn">deliver</span>(&#123;</div>
            <div class="code-line pl-4"><span class="code-prop">platforms</span>: <span class="code-str">'Web + Mobile'</span>,</div>
            <div class="code-line pl-4"><span class="code-prop">products</span>: <span class="code-str">'SaaS'</span>,</div>
            <div class="code-line pl-4"><span class="code-prop">systems</span>: <span class="code-str">'Cloud'</span>,</div>
            <div class="code-line pl-4"><span class="code-prop">approach</span>: <span class="code-str">'End to End'</span></div>
            <div class="code-line">&#125;);</div>
            <div class="code-line mt-3">
              <span class="code-keyword">await&nbsp;</span><span class="code-var">solution</span>.<span class="code-fn">launch</span>();
              <span class="cursor">|</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="scroll-indicator">
    <div class="scroll-mouse">
      <div class="scroll-dot"></div>
    </div>
    <span class="text-xs scroll-label mt-2">Scroll</span>
  </div>
</section>
